import { BaseDevice, CustomLayout, jingtaiV2LightAndSpeedRange } from '../../base_device'
import list_icon from '@/assets/img/device/mer68/Mer68_icon.png'
import { mer68VKCodes } from '../keycode/vkeycode'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { DevicePid, EffectIndex, KK } from '@/define/define'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_JTV2 } from '../../light/light_effect_list'

export class Mer68Max extends BaseDevice {
  name: string = 'Mer68_Max'
  icon: string = list_icon
  width: number = 708
  vkcodes = mer68VKCodes
  square = getDeviceKeySquare(DevicePid.CarotmasMer68)
  magneticAxis: boolean = true
  inoperableKeys: KK[] = [0x50a]
  fnFactoryKeys: KK[] = [0x100, 0x101, 0x102, 0x103, 0x104, 0x105, 0x106, 0x107, 0x108, 0x109, 0x10a, 0x10b, 0x10c, 0x302, 0x20b, 0x20c, 0x403, 0x501, 0x509, 0x50c, 0x50d, 0x50e, 0x40d]
  customLayout: CustomLayout = {
    0x10d: this.createSquare(2, 2, 87),
    0x200: this.createSquare(2, 2, 60),
    0x20d: this.createSquare(2, 2, 68),
    0x300: this.createSquare(2, 2, 72),
    0x30d: this.createSquare(2, 2, 99),
    0x0400: this.createSquare(2, 2, 100),
    0x040c: this.createSquare(2, 2, 72),
    0x500: this.createSquare(2, 2, 62),
    0x501: this.createSquare(2, 2, 62),
    0x502: this.createSquare(2, 2, 62),
    0x506: this.createSquare(2, 2, 240),
    0xe: this.createSquare(2, 2, 40),
  }

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_JTV2

  speedAllowValues: number[] = jingtaiV2LightAndSpeedRange()
  lightAllowValues: number[] = jingtaiV2LightAndSpeedRange()
  maxDelayTimer: number = 32768

  rate: number[] = [0.25, 0.5, 1, 2, 4, 8]
  sleepTimeValues: number[] = [60, 2 * 60, 3 * 60, 5 * 60, 15 * 60, 30 * 60, 1 * 60 * 60, 2 * 60 * 60, 0]
}
